import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { SchemaDescription } from 'yup';
import {
  StyledTableHeaderRow,
  StyledTableCell,
  StyledTableRow,
} from '../../CompanyProfiles/components/Table/StyledGridComponents';
import { FMT } from '../../../util/formatter-service';
import { WaterfallResult } from '../../../data-models/fund-waterfall.data-model';
import { waterfallResultsSummarySchema } from './useWaterfallResultsGrid';

export function WaterfallResultsSummaryRow({
  data,
  hasPerClassProceeds,
}: {
  data: Pick<WaterfallResult, 'gpNav' | 'lpNav' | 'slpNav'>;
  hasPerClassProceeds?: boolean;
}) {
  const { colors } = useTheme();

  const fieldDescriptionsMap = useMemo(() => {
    return new Map(
      Object.entries(waterfallResultsSummarySchema().pick(['gpNav', 'lpNav', 'slpNav']).fields).map(
        ([fieldKey, value]) => [fieldKey as keyof WaterfallResult, value.describe() as SchemaDescription]
      )
    );
  }, []);

  // With per-class pools: lp(4) slp(6) gp(8)
  // Without: lp(3) slp(4) gp spans(5-7)
  const lpCol = hasPerClassProceeds ? 4 : 3;
  const slpCol = hasPerClassProceeds ? 6 : 4;
  const gpCol = hasPerClassProceeds ? 8 : '5 / span 3';

  return (
    <>
      <StyledTableHeaderRow style={{ marginTop: '1rem' }}>
        <StyledTableCell style={{ gridColumn: lpCol }} type='numeric' header>
          {fieldDescriptionsMap.get('lpNav')!.label}
        </StyledTableCell>
        <StyledTableCell style={{ gridColumn: slpCol }} type='numeric' header>
          {fieldDescriptionsMap.get('slpNav')!.label}
        </StyledTableCell>
        <StyledTableCell style={{ gridColumn: gpCol }} type={'numeric'} header>
          {fieldDescriptionsMap.get('gpNav')!.label}
        </StyledTableCell>
      </StyledTableHeaderRow>

      <StyledTableRow style={{ background: colors.primary[10] }}>
        <StyledTableCell style={{ gridColumn: lpCol }} type={'numeric'}>
          {FMT.format(fieldDescriptionsMap.get('lpNav')!.meta!.formatter!, data.lpNav)}
        </StyledTableCell>
        <StyledTableCell style={{ gridColumn: slpCol }} type={'numeric'}>
          {FMT.format(fieldDescriptionsMap.get('slpNav')!.meta!.formatter!, data.slpNav)}
        </StyledTableCell>
        <>
          <StyledTableCell type={'numeric'} style={{ gridColumn: gpCol }}>
            {FMT.format(fieldDescriptionsMap.get('gpNav')!.meta!.formatter!, data.gpNav)}
          </StyledTableCell>
        </>
      </StyledTableRow>
    </>
  );
}
